import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import LanguagePicker from '../components/product-layout/LanguagePicker/languagePicker.js'
import ProductLayout from '../components/product-layout'
import {useHbsCompiler} from '../react-hooks/useContentCompiler'
import {useApplicationContext} from '../provider'
import {REQUEST_TITLE_SEPARATOR, REQUIRED_REQUEST_TITLE_SEPARATOR} from '../utils/bt-constant'
import { extractAndLoadScripts } from '../utils/scriptLoader'
import Loader from './Loader'

export const query = graphql`
query ($fileAbsolutePath:String!) {
  file (absolutePath:{eq:$fileAbsolutePath}){
    fields {
      rawBody
      frontmatter {
        title
        platform
        nextPage {
          title
          link
        }
        seeAlso{
          title
          link
          sdk,
          hbsHelper
        }
        noindex
        hideTitle
        hidden
        searchPriority
        searchKeywords
      }
    }
  }
}
`

const Btfile = (props) => {
  const {pathContext: {config, leftNav, referenceData = {}} } = props
  const { handleBarCompiler } = useApplicationContext()  
  const {rawBody, frontmatter} = props.data.file.fields;
  if(frontmatter && frontmatter.title) frontmatter.title = frontmatter.title.replace(REQUEST_TITLE_SEPARATOR, REQUIRED_REQUEST_TITLE_SEPARATOR)
  const { content, loaded, data:context } = useHbsCompiler(
    rawBody,
    frontmatter,
    props.location,
    handleBarCompiler,
    leftNav,
    referenceData,
    {nextPageLink:frontmatter.nextPage,seeAlsoLinks:frontmatter.seeAlso}
  )
  useEffect(() => {
    if (loaded) {
      // eslint-disable-next-line no-new
      new window.BTBaseLib.SyntaxHighlightManager()
      // eslint-disable-next-line no-new
      new window.BTBaseLib.CodeManager()
      // eslint-disable-next-line no-new
      new window.BTBaseLib.BaseView()

      const elements = document.getElementsByName(location.hash.replace("#", ""));
      if(elements.length > 0) elements[0].scrollIntoView()
      extractAndLoadScripts(content)
    }
  }, [loaded]) 
  const pageHeader = (
    <div className="page-header page-header--guides ">
      <div className="page-header__inner" >
        {frontmatter.hideTitle ? null: (<h1 className="page-header__title-group">
          <span className= "page-header__section">  {context.pageSection? context.pageSection : null }</span>
          <span className="page-header--title-divider">/</span>
          <span className="page-header__title">{frontmatter.title}</span>
        </h1>)}
          {
            frontmatter.platform && frontmatter.platform !== 'none' &&
            <LanguagePicker  context={context}/>
          }
      </div>
    </div>
  )
    
    return (
      //  <Loader />
      loaded ?  (
        <ProductLayout hideRightNav pageHeader={pageHeader} config={config}  leftNav={leftNav} location={props.location} context={context} loaded={loaded}>
          
            <div dangerouslySetInnerHTML={{__html: content}} />
            {/* <div dangerouslySetInnerHTML={{__html: props.data.markdownRemark.html}} /> */}
       </ProductLayout>  
       ) : <Loader /> 
    )
}

export default Btfile
